import { c as _c } from "react/compiler-runtime";
import { PowerBIAnalytics, PremiumAnalyticsPages } from "@components/analytics/power-bi/power-bi-analytics";

/** Renders project analytics under projects tab in analytics*/
export function ProjectsAnalytics() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PowerBIAnalytics pageDisplayName={PremiumAnalyticsPages.projects} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}